"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.LootboxRedemptionTransactionHistoryItemToJSON = exports.LootboxRedemptionTransactionHistoryItemFromJSONTyped = exports.LootboxRedemptionTransactionHistoryItemFromJSON = void 0;
var runtime_1 = require("../runtime");
function LootboxRedemptionTransactionHistoryItemFromJSON(json) {
    return LootboxRedemptionTransactionHistoryItemFromJSONTyped(json, false);
}
exports.LootboxRedemptionTransactionHistoryItemFromJSON = LootboxRedemptionTransactionHistoryItemFromJSON;
function LootboxRedemptionTransactionHistoryItemFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !(0, runtime_1.exists)(json, 'id') ? undefined : json['id'],
        'lootboxName': !(0, runtime_1.exists)(json, 'lootboxName') ? undefined : json['lootboxName'],
        'prizeName': !(0, runtime_1.exists)(json, 'prizeName') ? undefined : json['prizeName'],
        'prizeValue': !(0, runtime_1.exists)(json, 'prizeValue') ? undefined : json['prizeValue'],
        'prizeType': !(0, runtime_1.exists)(json, 'prizeType') ? undefined : json['prizeType'],
        'prizeImage': !(0, runtime_1.exists)(json, 'prizeImage') ? undefined : json['prizeImage'],
        'burnedAt': !(0, runtime_1.exists)(json, 'burnedAt') ? undefined : (new Date(json['burnedAt'])),
        'createdAt': !(0, runtime_1.exists)(json, 'createdAt') ? undefined : (new Date(json['createdAt'])),
        'description': !(0, runtime_1.exists)(json, 'description') ? undefined : json['description'],
    };
}
exports.LootboxRedemptionTransactionHistoryItemFromJSONTyped = LootboxRedemptionTransactionHistoryItemFromJSONTyped;
function LootboxRedemptionTransactionHistoryItemToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'lootboxName': value.lootboxName,
        'prizeName': value.prizeName,
        'prizeValue': value.prizeValue,
        'prizeType': value.prizeType,
        'prizeImage': value.prizeImage,
        'burnedAt': value.burnedAt === undefined ? undefined : (value.burnedAt.toISOString()),
        'createdAt': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'description': value.description,
    };
}
exports.LootboxRedemptionTransactionHistoryItemToJSON = LootboxRedemptionTransactionHistoryItemToJSON;
